export const CUSTOMER_LOADING = "CUSTOMER_LOADING";
export const CUSTOMER_FAIL = "CUSTOMER_FAIL";
export const CUSTOMER_SUCCESS = "CUSTOMER_SUCCESS";


export interface CustomerLoading {

    type: typeof CUSTOMER_LOADING

}


export interface CustomerSuccess {

    type: typeof CUSTOMER_SUCCESS,
    payload: any
    
}


export interface CustomerFail {

    type: typeof CUSTOMER_FAIL,
    payload: any
    
}


export type CustomerDispatchTypes = CustomerFail | CustomerLoading | CustomerSuccess;